import { render, staticRenderFns } from "./Follow-ups.vue?vue&type=template&id=ef78f6d4"
import script from "./Follow-ups.vue?vue&type=script&lang=js"
export * from "./Follow-ups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports